module.exports = __webpack_public_path__ + "static/img/rec.ed4ee04f.png";